import PropTypes from "prop-types";
import React from "react";
import Select from "../../../common/controls/Select";

const quarters = [
    {value: "", label: ""},
    {value: "1", label: "Q1 (Jan 1 - Mar 31)"},
    {value: "2", label: "Q2 (Apr 1 - Jun 30)"},
    {value: "3", label: "Q3 (Jul 1 - Sep 30)"},
    {value: "4", label: "Q4 (Oct 1 - Dec 31)"},
];

const QuarterYearSelect = ({
                               quarter,
                               year,
                               min,
                               max,
                               onChange,
                               expanded = false,
                               disabled = true,
                               required = false,
                           }) => {
    const minYear = min[0], maxYear = max[0];
    const years = [];
    for (let i = maxYear; i >= minYear; i--) {
        years.push(i.toString());
    }

    const quarterOptions = quarters;
    const yearOptions = years.map((y) => ({ label: y, value: y }));
    yearOptions.unshift({ label: "", value: "" });


    return (
        <div className="quarterFields export-datecontrols">
            <div className="form-group row">
                    <div className="col-sm-7">
                        <Select
                            value={quarter}
                            width="100%"
                            className="quarter_select quarter_from partdep form-control"
                            disabled={disabled}
                            onCommitChange={(v) => onChange("quarter", v)}
                            options={quarterOptions}
                            required={required}
                        />
                    </div>
                    <div className="col-sm-5">
                        <Select
                            value={year}
                            className="year_select year_from partdep form-control"
                            disabled={disabled}
                            onCommitChange={(v) => onChange("year", v)}
                            options={yearOptions}
                            required={required}
                        />
                    </div>
            </div>
        </div>
    );
};

QuarterYearSelect.propTypes = {
    quarter: PropTypes.string,
    year: PropTypes.string,
    min: PropTypes.array,
    max: PropTypes.array,
    onChange: PropTypes.func,
    expanded: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
};

export default QuarterYearSelect;



// WEBPACK FOOTER //
// ./app/lib/hex/views/components/QuarterYearSelect.js